import types from '../data/monitoringTypes.json'
import LimitManager from './limitManager'

const limits = {
    limits: 'limits',
    overriddenLimits: 'overriddenLimits'
}

const isResourceLimitEnabled = (resource, usageLimits) => {
    if (resource?.type === types.http.value && resource?.conditions) {
        return LimitManager.getConditionMonitoringIsEnabled(usageLimits)
    }

    if (resource?.type === types.tcp.value || resource?.type === types.udp.value) {
        return LimitManager.getPortMonitoringIsEnabled(usageLimits)
    }

    if (resource?.type === types.icmp.value) {
        return LimitManager.getPingMonitoringIsEnabled(usageLimits)
    }

    if (resource?.type === types.email_protocols.value) {
        return LimitManager.getEmailMonitoringIsEnabled(usageLimits)
    }

    return LimitManager.getResourceLimit(usageLimits) > 0
}

const calculateRemaining = (limit, length) => {
    const remaining = limit - length
    return remaining < 0 ? 0 : remaining
}

export {
    limits,
    calculateRemaining,
    isResourceLimitEnabled
}
